import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import SideBarProfile from '../SideBar/SideBarProfile';

import {
  faHome,
  faUser,
  faSignOut
} from '@fortawesome/pro-regular-svg-icons';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/pro-regular-svg-icons';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

import './navbarDrivers.css';

class NavbarDrivers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false
    };
    this.dropDown = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef = node => {
    this.wrapperRef = node;
  };

  handleClickOutside = e => {
    if (this.wrapperRef && !this.wrapperRef.contains(e.target)) {
      this.setState({ dropdownOpen: false });
    }
  };

  toggleNavBar = () =>
    this.setState({ dropdownOpen: !this.state.dropdownOpen });

  getItems = () => {
    const { status } = this.props;
    return [
      { name: 'Profile', href: '/profile', icon: faUser, active: true },
      {
        name: 'Dashboard',
        href: '/dashboard',
        icon: faHome,
        active: true
      },
      {
        name: 'Book',
        href: '/book',
        icon: faCalendarAlt,
        active: status === 'operating'
      },
      { name: 'Logout', href: '/logout', icon: faSignOut, active: true }
    ];
  };

  renderOperatingCity = city => {
    const { pathname } = this.props.history.location;
    if (pathname.includes(['/nyc', '/go', '/nyc/faq'])) {
      return (
        <Fragment>
          <FontAwesomeIcon
            icon={faMapMarkerAlt}
            className="city-location-icon"
          />
          {'New York City'}
        </Fragment>
      );
    } else if (pathname.includes(['/tor', '/tor/pro'])) {
      return (
        <Fragment>
          <FontAwesomeIcon
            icon={faMapMarkerAlt}
            className="city-location-icon"
          />
          {'Toronto'}
        </Fragment>
      );
    } else if (pathname.includes(['/sf', '/pro', '/plus', '/faq'])) {
      return (
        <Fragment>
          <FontAwesomeIcon
            icon={faMapMarkerAlt}
            className="city-location-icon"
          />
          {'San Francisco'}
        </Fragment>
      );
    }
    switch (city) {
      case 'toronto':
        return (
          <Fragment>
            <FontAwesomeIcon
              icon={faMapMarkerAlt}
              className="city-location-icon"
            />
            {'Toronto'}
          </Fragment>
        );
      case 'sf':
        return (
          <Fragment>
            <FontAwesomeIcon
              icon={faMapMarkerAlt}
              className="city-location-icon"
            />
            {'San Francisco'}
          </Fragment>
        );
      case 'new_york':
        return (
          <Fragment>
            <FontAwesomeIcon
              icon={faMapMarkerAlt}
              className="city-location-icon"
            />
            {'New York City'}
          </Fragment>
        );
      default:
        return null;
    }
  };

  render() {
    const {
      profileImage,
      firstName,
      status,
      operatingCity,
      history
    } = this.props;
    return history.location.pathname === '/downloadapp' ? null : (
      <div className="navbar-block-container">
        <div className="head nav navbar-nav header-city--flex">
          <div className="city-link dropdown-toggle city-name--log-in">
            {this.renderOperatingCity(operatingCity)}
          </div>
          <div ref={this.setWrapperRef} className="navbar__dropdown">
            <div
              className="navbar__dropdown--profile"
              onClick={() => this.toggleNavBar()}>
              <SideBarProfile
                status={status}
                firstName={firstName}
                profileImage={profileImage}
              />
            </div>
            {this.state.dropdownOpen ? (
              <div className="navbar__dropdown--container">
                {this.getItems().map((item, index) =>
                  item.active ? (
                    <div className="navbar__dropdown--link-container">
                      <Link
                        className="navbar__dropdown--link"
                        to={item.href}
                        onClick={() => this.toggleNavBar()}>
                        <div className="navbar__dropdown--link-icon">
                          <FontAwesomeIcon icon={item.icon} />
                        </div>
                        <div className="navbar__dropdown--link-text">
                          {item.name}
                        </div>
                      </Link>
                    </div>
                  ) : null
                )}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(NavbarDrivers);



// WEBPACK FOOTER //
// ./src/components/Layout/NavbarDrivers.js